import { TimeframeEnum } from '@api/index';
import { DateTime } from 'luxon';

export function getCurrentWeek(): [string, string] {
  const { start, end } = getStartWeekAndEndWeekDate();
  return [start.toISODate(), end.toISODate()];
}

export function getPreviousWeek(): [string, string] {
  const { start, end } = getStartWeekAndEndWeekDate();
  return [start.minus({ weeks: 1 }).toISODate(), end.minus({ weeks: 1 }).toISODate()];
}

export function getCurrentMonth(): [string, string] {
  const { start, end } = getStartMonthAndEndMonthDate();
  return [start.toISODate(), end.toISODate()];
}

export function getPreviousMonth(): [string, string] {
  const { start, end } = getStartMonthAndEndMonthDate();
  return [start.minus({ months: 1 }).toISODate(), end.minus({ months: 1 }).endOf('month').toISODate()];
}

export function getToday(): [string, string] {
  const today = DateTime.now().toISODate();
  return [today, today];
}

export function getLast30days(): [string, string] {
  const today = DateTime.local().startOf('day');
  return [today.minus({ days: 30 }).toISODate(), today.toISODate()];
}

export function getLastCalendarYear(): [string, string] {
  const today = DateTime.local().startOf('day');
  return [today.minus({ years: 1 }).toISODate(), today.toISODate()];
}

export function getTimeFrameFunctionMap() {
  return {
    [TimeframeEnum.Today]: getToday,
    [TimeframeEnum.CurrentWeek]: getCurrentWeek,
    [TimeframeEnum.PreviousWeek]: getPreviousWeek,
    [TimeframeEnum.CurrentMonth]: getCurrentMonth,
    [TimeframeEnum.PreviousMonth]: getPreviousMonth,
    [TimeframeEnum.Last30days]: getLast30days,
  };
}

function getStartWeekAndEndWeekDate(): { start: DateTime; end: DateTime } {
  const today = DateTime.local();
  return {
    start: today.startOf('week'),
    end: today.endOf('week'),
  };
}

function getStartMonthAndEndMonthDate(): { start: DateTime; end: DateTime } {
  const today = DateTime.local();
  return {
    start: today.startOf('month'),
    end: today.endOf('month'),
  };
}

export function toStartOfDayIso(date: DateTime): string {
  return date.startOf('day').toUTC().toISO();
}

export function toEndOfDayIso(date: DateTime): string {
  return date.plus({ days: 1 }).startOf('day').toUTC().toISO();
}
